import gql from 'graphql-tag';

import { UserProfileFragment, EducationProfileFragment } from './fragments/MyProfileFragment';
import { MyFavDepartmentsFragment } from './fragments/MyFavsFragment';

export const queryConfirmAdmissionMyInfo = gql`
  query ConfirmAdmissionMyInfo(
    $showLikes: Boolean = false
    $showEvents: Boolean = false
    $smallEvent: Boolean = false
    $includeRound: Boolean = false
    $roundDetails: Boolean = false
    $educationYear: Int = 2018
  ) {
    myProfile {
      id
      ...MyFavDepartmentsFragment
      userDetails {
        ...UserProfileFragment
      }
      educationProfiles(educationYear: $educationYear) {
        ...EducationProfileFragment
      }
    }
  }
  ${UserProfileFragment}
  ${MyFavDepartmentsFragment}
  ${EducationProfileFragment}
`;
